import PropTypes from 'prop-types'

import { Box, Typography } from '@material-ui/core'
import ToggleableSection from 'components/ToggleableSection'
import { withContext } from '../Context'
import TestScoreSelector from './TestScoreSelector'

type AcademicProfileSelectorProps = {
  segment: object
  onChange: (criteria: string, segmentName: string, value: any, operation: string) => void
}

export const AcademicProfileSelector = ({ segment, onChange }: AcademicProfileSelectorProps) => {
  return (
    <ToggleableSection title="Academic Profile">
      <Box pt={2}>
        <Typography
          variant="subtitle2"
          color="textPrimary"
          className="title"
        >
          Test Score Ranges
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
        >
          Only students whose reported scores fall within the selected range will be included.
        </Typography>
      </Box>
      <TestScoreSelector
        segmentName="ACT"
        segment={segment}
        onChange={onChange}
        min={1}
        max={36}
      />
      <TestScoreSelector
        segmentName="SAT"
        segment={segment}
        onChange={onChange}
        min={400}
        max={1600}
        rangeStep={10}
      />
      <TestScoreSelector
        label="Pre-ACT"
        segmentName="PACT"
        segment={segment}
        onChange={onChange}
        min={1}
        max={35}
      />
      <TestScoreSelector
        label="PSAT/NMSQT"
        segmentName="PSATNMSQT"
        segment={segment}
        onChange={onChange}
        min={320}
        max={1520}
        rangeStep={10}
      />
      <TestScoreSelector
        label="PSAT 10"
        segmentName="PSAT10"
        segment={segment}
        onChange={onChange}
        min={320}
        max={1520}
        rangeStep={10}
      />
      <TestScoreSelector
        label="PSAT 8/9"
        segmentName="PSAT89"
        segment={segment}
        onChange={onChange}
        min={240}
        max={1440}
        rangeStep={10}
      />
    </ToggleableSection>
  )
}

AcademicProfileSelector.propTypes = {
  segment: PropTypes.object,
  onChange: PropTypes.func.isRequired,
}

export default withContext(AcademicProfileSelector)
